module.exports = __webpack_public_path__ + "img/icon-small-cross.30d7a772.svg";